/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'welcome';
const componentName = 'welcome-email-localhost-settings';
const prefix = `${moduleName}.${componentName}`;

export const fromAddressLabel = `${prefix}.fromAddressLabel`;

export const ENGLISH = {
    [fromAddressLabel]: 'From Address',
};
